/**
 * UEFA Europa League - competition rule, every season.
 *
 * Identity: API-Football league.id = 3.
 */

import { UEFA_LEAGUE_PHASE_BRACKET } from '../brackets/uefaLeaguePhaseBracket';
import type { CompetitionRule } from '../types';

const rule: CompetitionRule = {
  leagueCode: '3',
  tieBracket: UEFA_LEAGUE_PHASE_BRACKET,
};

export default rule;
